import _ from "lodash";

function getCountries(rawData) {
  if (_.isEmpty(rawData)) {
    return;
  }
  let countriesList = new Set();

  for (const items in rawData) {
    for (const countryName in rawData[items]) {
      countriesList.add(countryName);
    }
  }

  countriesList = _.orderBy(Array.from(countriesList), [country => country.toLowerCase()]);
  return countriesList;
}

function getSites(rawData, chosenCountries = []) {
  if (_.isEmpty(rawData) || chosenCountries.length === 0) {
    return;
  }
  let sitesList = new Set();

  for (const items in rawData) {
    for (const countryName in rawData[items]) {
      if (chosenCountries === "all" || (Array.isArray(chosenCountries) && chosenCountries.length < 1)) {
        const siteData = rawData[items][countryName];

        for (const siteName in siteData) {
          sitesList.add(siteName);
        }
      } else {
        if (chosenCountries.includes(countryName)) {
          const siteData = rawData[items][countryName];

          for (const siteName in siteData) {
            sitesList.add(siteName);
          }
        }
      }
    }
  }

  sitesList = _.orderBy(Array.from(sitesList), [site => site.toLowerCase()]);
  return sitesList;
}

function CONVERT_DAYS(hour = 0) {
  if (hour <= 0) {
    return null;
  }

  const days = hour <= 0 ? Number(0) : hour > 0 && hour < 24 ? 0 : Math.floor(hour / 24);
  const reminder = hour % 24;
  const hours = Math.floor(reminder);

  return { d: days, h: hours };
}

function ConvertHoursToDays(hours = 0) {
  const d = hours <= 0 ? Number(0) : hours > 0 && hours < 24 ? 0 : Math.floor(Number(hours) / 24);
  return d;
}

function GET_QUERIES_PERCENTAGE(rawData, chosenCountries = [], chosenSites = []) {
  if (_.isEmpty(rawData) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return;
  }

  let response = {};

  let queryOpen = 0;
  let queryRespond = 0;
  let queryClosed = 0;

  const listSite = new Set();

  const PREFIX_QUERY_OPEN = "queryOpen";
  const PREFIX_QUERY_RESPONSE = "queryResponded";
  const PREFIX_QUERY_CLOSE = "queryClosed";

  for (const activityName in rawData) {
    const activityData = rawData[activityName];
    for (const countryName in activityData) {
      const countryData = activityData[countryName];
      for (const siteName in countryData) {
        const siteData = countryData[siteName];

        // Iterate the bucket days range
        for (const dayRange in siteData) {
          const rangedata = siteData[dayRange];

          // Iterate activities
          if (chosenCountries === "all" || (Array.isArray(chosenCountries) && chosenCountries.length < 1)) {
            if (chosenSites[0] === "all") {
              queryOpen += parseInt(rangedata[PREFIX_QUERY_OPEN]);
              queryRespond += parseInt(rangedata[PREFIX_QUERY_RESPONSE]);
              queryClosed += parseInt(rangedata[PREFIX_QUERY_CLOSE]);

              listSite.add(siteName);
            } else {
              if (chosenSites.includes(siteName)) {
                queryOpen += parseInt(rangedata[PREFIX_QUERY_OPEN]);
                queryRespond += parseInt(rangedata[PREFIX_QUERY_RESPONSE]);
                queryClosed += parseInt(rangedata[PREFIX_QUERY_CLOSE]);

                listSite.add(siteName);
              }
            }
          } else {
            if (chosenSites[0] === "all") {
              queryOpen += parseInt(rangedata[PREFIX_QUERY_OPEN]);
              queryRespond += parseInt(rangedata[PREFIX_QUERY_RESPONSE]);
              queryClosed += parseInt(rangedata[PREFIX_QUERY_CLOSE]);

              listSite.add(siteName);
            } else {
              if (chosenSites.includes(siteName)) {
                queryOpen += parseInt(rangedata[PREFIX_QUERY_OPEN]);
                queryRespond += parseInt(rangedata[PREFIX_QUERY_RESPONSE]);
                queryClosed += parseInt(rangedata[PREFIX_QUERY_CLOSE]);

                listSite.add(siteName);
              }
            }
          }
        }
      }
    }
  }

  const totalData = queryOpen + queryRespond + queryClosed;

  response = {
    open: Number((queryOpen / totalData) * 100).toFixed(0),
    response: Number((queryRespond / totalData) * 100).toFixed(0),
    closed: Number((queryClosed / totalData) * 100).toFixed(0)
  };

  return response;
}

function GET_AVERAGE_TIME_ACTIVITY_STATUS(rawData, chosenCountries = [], chosenSites = []) {
  if (_.isEmpty(rawData) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return;
  }

  let response = {};

  let avgEntryCompleted = 0;
  let avgApproved = 0;
  let avgVerified = 0;
  let avgSignedOff = 0;

  let counterEntryCompleted = 0;
  let counterApproved = 0;
  let counterVerified = 0;
  let counterSignedOff = 0;

  const longestEc = [];
  const longestAp = [];
  const longestVv = [];
  const longestSo = [];

  const listSites = new Set();

  const PREFIX_QUERY_ENTRY_COMPLETED = "hoursEntryCompleted";
  const PREFIX_QUERY_APPROVED = "hoursApproved";
  const PREFIX_QUERY_VERIFIED = "hoursVerified";
  const PREFIX_QUERY_SIGNED_OFF = "hoursSigned";

  for (const activityName in rawData) {
    const activityData = rawData[activityName];

    chosenCountries.forEach(countryName => {
      if (countryName in activityData) {
        const countryData = activityData[countryName];

        chosenSites.forEach(siteName => {
          if (siteName in countryData) {
            const siteData = countryData[siteName];

            if (Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]) > 0) {
              avgEntryCompleted += Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]);
              counterEntryCompleted++;
            }
            if (Number(siteData[PREFIX_QUERY_APPROVED]) > 0) {
              avgApproved += Number(siteData[PREFIX_QUERY_APPROVED]);
              counterApproved++;
            }
            if (Number(siteData[PREFIX_QUERY_VERIFIED]) > 0) {
              avgVerified += Number(siteData[PREFIX_QUERY_VERIFIED]);
              counterVerified++;
            }
            if (Number(siteData[PREFIX_QUERY_SIGNED_OFF]) > 0) {
              avgSignedOff += Number(siteData[PREFIX_QUERY_SIGNED_OFF]);
              counterSignedOff++;
            }

            listSites.add(siteName);

            const ec = siteData[PREFIX_QUERY_ENTRY_COMPLETED];
            const ap = siteData[PREFIX_QUERY_APPROVED];
            const vv = siteData[PREFIX_QUERY_VERIFIED];
            const so = siteData[PREFIX_QUERY_SIGNED_OFF];

            // Get the longest activity here
            const indexEc = _.findIndex(longestEc, ["label", activityName]);
            const indexAp = _.findIndex(longestAp, ["label", activityName]);
            const indexVv = _.findIndex(longestVv, ["label", activityName]);
            const indexSo = _.findIndex(longestSo, ["label", activityName]);

            if (indexEc < 0) {
              longestEc.push({ label: activityName, value: Number(ec) });
            } else {
              longestEc[indexEc].value += Number(ec);
            }

            if (indexAp < 0) {
              longestAp.push({ label: activityName, value: Number(ap) });
            } else {
              longestAp[indexAp].value += Number(ap);
            }

            if (indexVv < 0) {
              longestVv.push({ label: activityName, value: Number(vv) });
            } else {
              longestVv[indexVv].value += Number(vv);
            }

            if (indexSo < 0) {
              longestSo.push({ label: activityName, value: Number(so) });
            } else {
              longestSo[indexSo].value += Number(so);
            }
          }
        });
      }
    });
  }

  avgEntryCompleted = counterEntryCompleted ? avgEntryCompleted / counterEntryCompleted : 0;
  avgApproved = counterApproved ? avgApproved / counterApproved : 0;
  avgVerified = counterVerified ? avgVerified / counterVerified : 0;
  avgSignedOff = counterSignedOff ? avgSignedOff / counterSignedOff : 0;

  response = {
    avgEntryCompleted: CONVERT_DAYS(avgEntryCompleted),
    avgApproved: CONVERT_DAYS(avgApproved),
    avgVerified: CONVERT_DAYS(avgVerified),
    avgSignedOff: CONVERT_DAYS(avgSignedOff),
    longestEntryCompleted: _.slice(_.orderBy(longestEc, "value", "desc"), 0, 1)[0] ? _.slice(_.orderBy(longestEc, "value", "desc"), 0, 1)[0].label : null,
    longestApproved: _.slice(_.orderBy(longestAp, "value", "desc"), 0, 1)[0] ? _.slice(_.orderBy(longestAp, "value", "desc"), 0, 1)[0].label : null,
    longestVerified: _.slice(_.orderBy(longestVv, "value", "desc"), 0, 1)[0] ? _.slice(_.orderBy(longestVv, "value", "desc"), 0, 1)[0].label : null,
    longestSignedOff: _.slice(_.orderBy(longestSo, "value", "desc"), 0, 1)[0] ? _.slice(_.orderBy(longestSo, "value", "desc"), 0, 1)[0].label : null
  };

  return response;
}

function GET_TIME_ACTIVITIES_STATUS(rawData, chosenCountries = [], chosenSites = [], tabIndex = 0) {
  if (_.isEmpty(rawData)) {
    return;
  }
  const series = {};

  const dataEntryCompleted = [];
  const dataApproved = [];
  const dataVerified = [];
  const dataSignedOff = [];
  const labels = [];
  const tmpSortedData = [];

  const dataIndex = {};

  series["dataset"] = [];
  series["categories"] = [];

  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#7f69d4";
  series["dataset"][0] = {
    seriesname: "Entry Completed",
    color: primaryColor,
    data: []
  };
  series["dataset"][1] = { seriesname: "Approved", color: "#cab2d6", data: [] };
  series["dataset"][2] = { seriesname: "Verified", color: "#a6cee3", data: [] };
  series["dataset"][3] = {
    seriesname: "Signed Off",
    color: "#fb9a99",
    data: []
  };
  series["categories"][0] = { category: [] };

  const PREFIX_QUERY_ENTRY_COMPLETED = "hoursEntryCompleted";
  const PREFIX_QUERY_APPROVED = "hoursApproved";
  const PREFIX_QUERY_VERIFIED = "hoursVerified";
  const PREFIX_QUERY_SIGNED_OFF = "hoursSigned";

  for (const activityName in rawData) {
    const activityData = rawData[activityName];

    chosenCountries.forEach(countryname => {
      if (countryname in activityData) {
        const countryData = activityData[countryname];

        chosenSites.forEach(siteName => {
          if (siteName in countryData) {
            const siteData = countryData[siteName];

            switch (tabIndex) {
              case 0: {
                if (!(activityName in dataIndex)) {
                  dataIndex[activityName] = {
                    entryCompleted: { counter: 0, value: 0 },
                    approved: { counter: 0, value: 0 },
                    verified: { counter: 0, value: 0 },
                    signedOff: { counter: 0, value: 0 }
                  };
                }

                if (Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]) > 0) {
                  dataIndex[activityName]["entryCompleted"]["counter"] = 1; // counter is originally to calculate average.
                  // For easier rework, the max value will be divided by 1
                  if (siteData[PREFIX_QUERY_ENTRY_COMPLETED] > dataIndex[activityName]["entryCompleted"]["value"]) {
                    dataIndex[activityName]["entryCompleted"]["value"] = siteData[PREFIX_QUERY_ENTRY_COMPLETED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_APPROVED]) > 0) {
                  dataIndex[activityName]["approved"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_APPROVED] > dataIndex[activityName]["approved"]["value"]) {
                    dataIndex[activityName]["approved"]["value"] = siteData[PREFIX_QUERY_APPROVED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_VERIFIED]) > 0) {
                  dataIndex[activityName]["verified"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_VERIFIED] > dataIndex[activityName]["verified"]["value"]) {
                    dataIndex[activityName]["verified"]["value"] = siteData[PREFIX_QUERY_VERIFIED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_SIGNED_OFF]) > 0) {
                  dataIndex[activityName]["signedOff"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_SIGNED_OFF] > dataIndex[activityName]["signedOff"]["value"]) {
                    dataIndex[activityName]["signedOff"]["value"] = siteData[PREFIX_QUERY_SIGNED_OFF];
                  }
                }
                break;
              }
              case 1: {
                if (!(countryname in dataIndex)) {
                  dataIndex[countryname] = {
                    entryCompleted: { counter: 0, value: 0 },
                    approved: { counter: 0, value: 0 },
                    verified: { counter: 0, value: 0 },
                    signedOff: { counter: 0, value: 0 }
                  };
                }

                if (Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]) > 0) {
                  dataIndex[countryname]["entryCompleted"]["counter"] = 1; // counter is originally to calculate average.
                  // For easier rework, the max value will be divided by 1
                  if (siteData[PREFIX_QUERY_ENTRY_COMPLETED] > dataIndex[countryname]["entryCompleted"]["value"]) {
                    dataIndex[countryname]["entryCompleted"]["value"] = siteData[PREFIX_QUERY_ENTRY_COMPLETED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_APPROVED]) > 0) {
                  dataIndex[countryname]["approved"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_APPROVED] > dataIndex[countryname]["approved"]["value"]) {
                    dataIndex[countryname]["approved"]["value"] = siteData[PREFIX_QUERY_APPROVED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_VERIFIED]) > 0) {
                  dataIndex[countryname]["verified"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_VERIFIED] > dataIndex[countryname]["verified"]["value"]) {
                    dataIndex[countryname]["verified"]["value"] = siteData[PREFIX_QUERY_VERIFIED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_SIGNED_OFF]) > 0) {
                  dataIndex[countryname]["signedOff"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_SIGNED_OFF] > dataIndex[countryname]["signedOff"]["value"]) {
                    dataIndex[countryname]["signedOff"]["value"] = siteData[PREFIX_QUERY_SIGNED_OFF];
                  }
                }

                break;
              }
              case 2: {
                if (!(siteName in dataIndex)) {
                  dataIndex[siteName] = {
                    entryCompleted: { counter: 0, value: 0 },
                    approved: { counter: 0, value: 0 },
                    verified: { counter: 0, value: 0 },
                    signedOff: { counter: 0, value: 0 }
                  };
                }

                if (Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]) > 0) {
                  dataIndex[siteName]["entryCompleted"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_ENTRY_COMPLETED] > dataIndex[siteName]["entryCompleted"]["value"]) {
                    dataIndex[siteName]["entryCompleted"]["value"] = siteData[PREFIX_QUERY_ENTRY_COMPLETED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_APPROVED]) > 0) {
                  dataIndex[siteName]["approved"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_APPROVED] > dataIndex[siteName]["approved"]["value"]) {
                    dataIndex[siteName]["approved"]["value"] = siteData[PREFIX_QUERY_APPROVED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_VERIFIED]) > 0) {
                  dataIndex[siteName]["verified"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_VERIFIED] > dataIndex[siteName]["verified"]["value"]) {
                    dataIndex[siteName]["verified"]["value"] = siteData[PREFIX_QUERY_VERIFIED];
                  }
                }
                if (Number(siteData[PREFIX_QUERY_SIGNED_OFF]) > 0) {
                  dataIndex[siteName]["signedOff"]["counter"] = 1;
                  if (siteData[PREFIX_QUERY_SIGNED_OFF] > dataIndex[siteName]["signedOff"]["value"]) {
                    dataIndex[siteName]["signedOff"]["value"] = siteData[PREFIX_QUERY_SIGNED_OFF];
                  }
                }
                break;
              }
              default:
                break;
            }
          }
        });
      }
    });
  }

  for (const item in dataIndex) {
    labels.push(item);

    const valueEntryCompleted = dataIndex[item]["entryCompleted"]["value"] / dataIndex[item]["entryCompleted"]["counter"];
    const valueEntryApproved = dataIndex[item]["approved"]["value"] / dataIndex[item]["approved"]["counter"];
    const valueEntryVerified = dataIndex[item]["verified"]["value"] / dataIndex[item]["verified"]["counter"];
    const valueEntrySignedOff = dataIndex[item]["signedOff"]["value"] / dataIndex[item]["signedOff"]["counter"];

    dataEntryCompleted.push(Number(valueEntryCompleted));
    dataApproved.push(Number(valueEntryApproved));
    dataVerified.push(Number(valueEntryVerified));
    dataSignedOff.push(Number(valueEntrySignedOff));
  }

  const lenghtData = dataEntryCompleted.length;
  for (let i = 0; i < lenghtData; i++) {
    tmpSortedData.push({
      label: labels[i],
      entry: dataEntryCompleted[i],
      approved: dataApproved[i],
      verified: dataVerified[i],
      sign: dataSignedOff[i]
    });
  }

  const sortedData = _.orderBy(tmpSortedData, ["entry", "label"], ["desc", "asc"]);

  const categoriesData = sortedData.map(item => ({ label: item.label }));
  const entrydata = sortedData.map(item => ({ value: item.entry }));
  const approveddata = sortedData.map(item => ({ value: item.approved }));
  const verifieddata = sortedData.map(item => ({ value: item.verified }));
  const signdata = sortedData.map(item => ({ value: item.sign }));

  series["categories"][0].category = categoriesData;
  series["dataset"][0].data = Array.isArray(entrydata) && entrydata.length > 0 ? entrydata.map(n => (n.value != 0 && !isNaN(n.value) ? { value: ConvertHoursToDays(n.value) } : { showValue: 0 })) : [];
  series["dataset"][1].data = Array.isArray(approveddata) && approveddata.length > 0 ? approveddata.map(n => (n.value != 0 && !isNaN(n.value) ? { value: ConvertHoursToDays(n.value) } : { showValue: 0 })) : [];
  series["dataset"][2].data = Array.isArray(verifieddata) && verifieddata.length > 0 ? verifieddata.map(n => (n.value != 0 && !isNaN(n.value) ? { value: ConvertHoursToDays(n.value) } : { showValue: 0 })) : [];
  series["dataset"][3].data = Array.isArray(signdata) && signdata.length > 0 ? signdata.map(n => (n.value != 0 && !isNaN(n.value) ? { value: ConvertHoursToDays(n.value) } : { showValue: 0 })) : [];

  return series;
}

function GET_TIME_ACTIVITIES_PERCENTAGE(rawData, chosenCountries = [], chosenSites = [], tabIndex = 0) {
  if (_.isEmpty(rawData)) {
    return;
  }
  const series = {};
  const csvData = {};

  const dataEntryCompleted = [];
  const dataApproved = [];
  const dataVerified = [];
  const dataSignedOff = [];
  const labels = [];
  const tmpSortedData = [];

  const tabIndexActivities = {};
  const tabIndexCountries = {};
  const tabIndexSite = {};

  series["dataset"] = [];
  series["categories"] = [];
  csvData["dataset"] = [];
  csvData["categories"] = [];

  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#7f69d4";
  series["dataset"][0] = {
    seriesname: "Entry Completed",
    color: primaryColor,
    data: []
  };
  series["dataset"][1] = { seriesname: "Approved", color: "#cab2d6", data: [] };
  series["dataset"][2] = { seriesname: "Verified", color: "#a6cee3", data: [] };
  series["dataset"][3] = {
    seriesname: "Signed Off",
    color: "#fb9a99",
    data: []
  };
  series["categories"][0] = { category: [] };

  const PREFIX_QUERY_ENTRY_COMPLETED = "totalEntry";
  const PREFIX_QUERY_APPROVED = "totalApproved";
  const PREFIX_QUERY_VERIFIED = "totalVerified";
  const PREFIX_QUERY_SIGNED_OFF = "totalSigned";

  for (const activityName in rawData) {
    const activityData = rawData[activityName];

    chosenCountries.forEach(countryname => {
      if (countryname in activityData) {
        const countryData = activityData[countryname];

        chosenSites.forEach(siteName => {
          if (siteName in countryData) {
            const siteData = countryData[siteName];
            switch (tabIndex) {
              case 0: {
                if (!(activityName in tabIndexActivities)) {
                  tabIndexActivities[activityName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                }

                tabIndexActivities[activityName] = {
                  entryCompleted: tabIndexActivities[activityName].entryCompleted + Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]),
                  approved: tabIndexActivities[activityName].approved + Number(siteData[PREFIX_QUERY_APPROVED]),
                  verified: tabIndexActivities[activityName].verified + Number(siteData[PREFIX_QUERY_VERIFIED]),
                  signedOff: tabIndexActivities[activityName].signedOff + Number(siteData[PREFIX_QUERY_SIGNED_OFF])
                };
                break;
              }
              case 1: {
                if (!(countryname in tabIndexCountries)) {
                  tabIndexCountries[countryname] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                }

                tabIndexCountries[countryname] = {
                  entryCompleted: tabIndexCountries[countryname].entryCompleted + Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]),
                  approved: tabIndexCountries[countryname].approved + Number(siteData[PREFIX_QUERY_APPROVED]),
                  verified: tabIndexCountries[countryname].verified + Number(siteData[PREFIX_QUERY_VERIFIED]),
                  signedOff: tabIndexCountries[countryname].signedOff + Number(siteData[PREFIX_QUERY_SIGNED_OFF])
                };
                break;
              }
              case 2: {
                if (!(siteName in tabIndexSite)) {
                  tabIndexSite[siteName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                }

                tabIndexSite[siteName] = {
                  entryCompleted: tabIndexSite[siteName].entryCompleted + Number(siteData[PREFIX_QUERY_ENTRY_COMPLETED]),
                  approved: tabIndexSite[siteName].approved + Number(siteData[PREFIX_QUERY_APPROVED]),
                  verified: tabIndexSite[siteName].verified + Number(siteData[PREFIX_QUERY_VERIFIED]),
                  signedOff: tabIndexSite[siteName].signedOff + Number(siteData[PREFIX_QUERY_SIGNED_OFF])
                };
                break;
              }
              default:
                break;
            }
          }
        });
      }
    });
  }

  // Sort the highest values
  switch (tabIndex) {
    case 0: {
      for (const item in tabIndexActivities) {
        labels.push(item);

        const total = Number(tabIndexActivities[item].entryCompleted) + Number(tabIndexActivities[item].approved) + Number(tabIndexActivities[item].verified) + Number(tabIndexActivities[item].signedOff);

        const valueEntryCompleted = Number((tabIndexActivities[item].entryCompleted / total) * 100).toFixed(2);
        const valueEntryApproved = Number((tabIndexActivities[item].approved / total) * 100).toFixed(2);
        const valueEntryVerified = Number((tabIndexActivities[item].verified / total) * 100).toFixed(2);
        const valueEntrySignedOff = Number((tabIndexActivities[item].signedOff / total) * 100).toFixed(2);

        dataEntryCompleted.push(valueEntryCompleted);
        dataApproved.push(valueEntryApproved);
        dataVerified.push(valueEntryVerified);
        dataSignedOff.push(valueEntrySignedOff);
      }
      break;
    }
    case 1: {
      for (const item in tabIndexCountries) {
        labels.push(item);

        const total = Number(tabIndexCountries[item].entryCompleted) + Number(tabIndexCountries[item].approved) + Number(tabIndexCountries[item].verified) + Number(tabIndexCountries[item].signedOff);

        const valueEntryCompleted = Number((tabIndexCountries[item].entryCompleted / total) * 100).toFixed(2);
        const valueEntryApproved = Number((tabIndexCountries[item].approved / total) * 100).toFixed(2);
        const valueEntryVerified = Number((tabIndexCountries[item].verified / total) * 100).toFixed(2);
        const valueEntrySignedOff = Number((tabIndexCountries[item].signedOff / total) * 100).toFixed(2);

        dataEntryCompleted.push(valueEntryCompleted);
        dataApproved.push(valueEntryApproved);
        dataVerified.push(valueEntryVerified);
        dataSignedOff.push(valueEntrySignedOff);
      }
      break;
    }
    case 2: {
      for (const item in tabIndexSite) {
        labels.push(item);

        const total = Number(tabIndexSite[item].entryCompleted) + Number(tabIndexSite[item].approved) + Number(tabIndexSite[item].verified) + Number(tabIndexSite[item].signedOff);

        const valueEntryCompleted = Number((tabIndexSite[item].entryCompleted / total) * 100).toFixed(2);
        const valueEntryApproved = Number((tabIndexSite[item].approved / total) * 100).toFixed(2);
        const valueEntryVerified = Number((tabIndexSite[item].verified / total) * 100).toFixed(2);
        const valueEntrySignedOff = Number((tabIndexSite[item].signedOff / total) * 100).toFixed(2);

        dataEntryCompleted.push(valueEntryCompleted);
        dataApproved.push(valueEntryApproved);
        dataVerified.push(valueEntryVerified);
        dataSignedOff.push(valueEntrySignedOff);
      }
    }
  }

  const lenghtData = dataEntryCompleted.length;

  for (let i = 0; i < lenghtData; i++) {
    tmpSortedData.push({
      label: labels[i],
      entry: Number(dataEntryCompleted[i]),
      approved: Number(dataApproved[i]),
      verified: Number(dataVerified[i]),
      sign: Number(dataSignedOff[i])
    });
  }

  const sortedData = _.orderBy(tmpSortedData, ["entry", "label"], ["desc", "asc"]);

  const categoriesData = sortedData.map(item => ({ label: item.label }));
  const entrydata = sortedData.map(item => ({ value: item.entry }));
  const approveddata = sortedData.map(item => ({ value: item.approved }));
  const verifieddata = sortedData.map(item => ({ value: item.verified }));
  const signdata = sortedData.map(item => ({ value: item.sign }));

  series["categories"][0].category = categoriesData;
  series["dataset"][0].data = Array.isArray(entrydata) && entrydata.length > 0 ? entrydata.map(n => (n.value != 0 ? { value: Number(n.value).toFixed(0) } : { showValue: 0 })) : [];
  series["dataset"][1].data = Array.isArray(approveddata) && approveddata.length > 0 ? approveddata.map(n => (n.value != 0 ? { value: Number(n.value).toFixed(0) } : { showValue: 0 })) : [];
  series["dataset"][2].data = Array.isArray(verifieddata) && verifieddata.length > 0 ? verifieddata.map(n => (n.value != 0 ? { value: Number(n.value).toFixed(0) } : { showValue: 0 })) : [];
  series["dataset"][3].data = Array.isArray(signdata) && signdata.length > 0 ? signdata.map(n => (n.value != 0 ? { value: Number(n.value).toFixed(0) } : { showValue: 0 })) : [];

  csvData["categories"] = categoriesData;
  csvData["dataset"][0] = entrydata;
  csvData["dataset"][1] = approveddata;
  csvData["dataset"][2] = verifieddata;
  csvData["dataset"][3] = signdata;

  return {
    series,
    csvData
  };
}

function GET_FORM_STATUS_DATA(rawData, chosenCountries = [], chosenSites = []) {
  if (_.isEmpty(rawData) || chosenCountries.length === 0 || chosenSites.length === 0) {
    return {
      entryCompleted: [],
      approved: [],
      verified: [],
      signOff: [],
      categories: []
    };
  }
  let response = {};

  const entryCompleted = [];
  const approved = [];
  const verified = [];
  const signOff = [];
  let categories = [];

  const PREFIX_QUERY_ENTRY_COMPLETED = "totalEntry";
  const PREFIX_QUERY_APPROVED = "totalApproved";
  const PREFIX_QUERY_VERIFIED = "totalVerified";
  const PREFIX_QUERY_SIGNED_OFF = "totalSigned";

  chosenCountries.forEach(countryName => {
    if (countryName in rawData) {
      const countryData = rawData[countryName];
      chosenSites.forEach(siteName => {
        if (siteName in countryData) {
          const siteData = countryData[siteName];

          for (const day in siteData) {
            const ec = parseInt(siteData[day][PREFIX_QUERY_ENTRY_COMPLETED]);
            const ap = parseInt(siteData[day][PREFIX_QUERY_APPROVED]);
            const vv = parseInt(siteData[day][PREFIX_QUERY_VERIFIED]);
            const so = parseInt(siteData[day][PREFIX_QUERY_SIGNED_OFF]);

            categories.push({ label: day });
            const index = _.findIndex(entryCompleted, ["label", day]);

            if (index < 0) {
              entryCompleted.push(ec != 0 ? { label: day, value: ec } : { label: day, showValue: 0, value: 0 });
              approved.push(ap != 0 ? { label: day, value: ap } : { label: day, showValue: 0, value: 0 });
              verified.push(vv != 0 ? { label: day, value: vv } : { label: day, showValue: 0, value: 0 });
              signOff.push(so != 0 ? { label: day, value: so } : { label: day, showValue: 0, value: 0 });
            } else {
              entryCompleted[index].value += parseInt(ec);
              approved[index].value += parseInt(ap);
              verified[index].value += parseInt(vv);
              signOff[index].value += parseInt(so);
            }
          }
        }
      });
    }
  });

  categories = _.uniqBy(categories, "label");

  const tmpCategories = categories[3];
  const tmpEntryCompleted = entryCompleted[3];
  const tmpApproved = approved[3];
  const tmpVerified = verified[3];
  const tmpSignOff = signOff[3];

  categories[3] = categories[2];
  categories[2] = categories[1];
  categories[1] = tmpCategories;

  entryCompleted[3] = entryCompleted[2];
  entryCompleted[2] = entryCompleted[1];
  entryCompleted[1] = tmpEntryCompleted;

  approved[3] = approved[2];
  approved[2] = approved[1];
  approved[1] = tmpApproved;

  verified[3] = verified[2];
  verified[2] = verified[1];
  verified[1] = tmpVerified;

  signOff[3] = signOff[2];
  signOff[2] = signOff[1];
  signOff[1] = tmpSignOff;

  response = {
    categories,
    entryCompleted,
    approved,
    verified,
    signOff
  };

  return response;
}

function GET_TOP_TIME_ACTIVITIES(rawData, chosenCountries = [], chosenSites = [], tabIndex = 0) {
  if (_.isEmpty(rawData)) {
    return [];
  }

  let response = [];

  const PREFIX_QUERY_ENTRY_COMPLETED = "hoursEntryCompleted";
  const PREFIX_QUERY_APPROVED = "hoursApproved";
  const PREFIX_QUERY_VERIFIED = "hoursVerified";
  const PREFIX_QUERY_SIGNED_OFF = "hoursSigned";

  for (const activityName in rawData) {
    const activityData = rawData[activityName];
    chosenCountries.forEach(countryName => {
      if (countryName in activityData) {
        const countryData = activityData[countryName];
        chosenSites.forEach(siteName => {
          if (siteName in countryData) {
            const siteData = countryData[siteName];

            const ec = siteData[PREFIX_QUERY_ENTRY_COMPLETED];
            const ap = siteData[PREFIX_QUERY_APPROVED];
            const vv = siteData[PREFIX_QUERY_VERIFIED];
            const so = siteData[PREFIX_QUERY_SIGNED_OFF];

            const index = _.findIndex(response, ["label", activityName]);

            if (index < 0) {
              switch (tabIndex) {
                case 0:
                  if (ec > 0) {
                    response.push({
                      label: activityName,
                      value: ec,
                      counter: 1
                    });
                  }
                  break;
                case 1:
                  if (ap > 0) {
                    response.push({
                      label: activityName,
                      value: ap,
                      counter: 1
                    });
                  }
                  break;
                case 2:
                  if (vv > 0) {
                    response.push({
                      label: activityName,
                      value: vv,
                      counter: 1
                    });
                  }
                  break;
                case 3:
                  if (so > 0) {
                    response.push({
                      label: activityName,
                      value: so,
                      counter: 1
                    });
                  }
                  break;
                default:
                  break;
              }
            } else {
              switch (tabIndex) {
                case 0:
                  if (ec > 0) {
                    response[index].value += ec;
                    response[index].counter += 1;
                  }
                  break;
                case 1:
                  if (ap > 0) {
                    response[index].value += ap;
                    response[index].counter += 1;
                  }
                  break;
                case 2:
                  if (vv > 0) {
                    response[index].value += vv;
                    response[index].counter += 1;
                  }
                  break;
                case 3:
                  if (so > 0) {
                    response[index].value += so;
                    response[index].counter += 1;
                  }
                  break;
                default:
                  break;
              }
            }
          }
        });
      }
    });
  }

  response = response.map(rs => ({
    label: rs.label,
    value: ConvertHoursToDays(Number(rs.value / rs.counter))
  }));

  return _.slice(_.orderBy(response, "value", "desc"), 0, 5);
}

function GET_QUERIES_TIME_DATA(rawData, chosenCountries = [], chosenSites = []) {
  if (_.isEmpty(rawData)) {
    return;
  }
  const response = {};

  if (_.isEmpty(rawData)) {
    response["name"] = "-";
    response["value"] = { d: Number(0), h: Number(0) };

    return response;
  }

  const PREFIX_LONGEST_ACTIVITY = "longestActivity";
  const PREFIX_AVG_HOURS_QUERIES_CLOSE = "avgHourQueriesClose";

  chosenCountries.forEach(countryName => {
    if (countryName in rawData) {
      const countryData = rawData[countryName];

      chosenSites.forEach(siteName => {
        if (siteName in countryData) {
          const siteData = countryData[siteName];

          response["name"] = siteData[PREFIX_LONGEST_ACTIVITY];
          response["value"] = Number(siteData[PREFIX_AVG_HOURS_QUERIES_CLOSE]);
        }
      });
    }
  });

  if ("value" in response) {
    response["value"] = !Number.isNaN(response["value"]) ? CONVERT_DAYS(response["value"]) : { d: Number(0), h: Number(0) };
  }

  return response;
}

export { getCountries, getSites, GET_QUERIES_PERCENTAGE, GET_AVERAGE_TIME_ACTIVITY_STATUS, GET_TIME_ACTIVITIES_STATUS, GET_TIME_ACTIVITIES_PERCENTAGE, GET_FORM_STATUS_DATA, GET_TOP_TIME_ACTIVITIES, GET_QUERIES_TIME_DATA, CONVERT_DAYS };
